import React, { createContext } from 'react';

export type Theme = 'dark' | 'light' | 'system';
export type ThemeName = string;

export type ThemeProviderProps = {
  children: React.ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
  defaultThemeName?: ThemeName;
  themeNameStorageKey?: string;
  availableThemes?: ThemeName[];
};

export type ThemeProviderState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'dark' | 'light';
  themeName: ThemeName;
  setThemeName: (name: ThemeName) => void;
  availableThemes: ThemeName[];
};

export const initialState: ThemeProviderState = {
  theme: 'system',
  setTheme: () => null,
  resolvedTheme: 'light',
  themeName: 'default',
  setThemeName: () => null,
  availableThemes: [],
};

export const ThemeProviderContext =
  createContext<ThemeProviderState>(initialState);
